import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import axios, { AxiosError } from 'axios';
import { updateData } from '../../../../store/slices/userDataFormSlice';
import { TiTick } from 'react-icons/ti';
import { FormPersonalData } from '../form-curso/FormPersonalData';
import { SelectPayment } from '../SelectPayment';
import { SignDocument } from '../SignDocument';
import { SimpleFinishPayment } from '../SimpleFinishPayment';
import { CheckOutView } from "../CheckOutView";
import { WelcomeSection } from '../WelcomeSection';

export const FormSimplificado = () => {
  const steps = [
    'Bienvenida',
    'Datos personales',
    'Forma de pago',
    'Firma de acuerdo',
    'Finalizar pago',
    'Completado'
  ];

  const [currentStep, setCurrentStep] = useState(1);
  const [complete, setComplete] = useState(false);
  const [dataUser, setDataUser] = useState<any>([]);
  const [params] = useSearchParams();
  const [loading, setLoading] = useState(false);
  const [paymentMethodSelected, setPaymentMethodSelected] = useState('');
  const [error, setError] = useState(false);
  const [availableSuppliers, setAvailableSuppliers] = useState<{ id: number; description: string }[]>([]);
  const dispatch = useDispatch();

  useEffect(() => {
    fetchDataUser();
    localStorage.setItem('type_form', 'registro_simplificado');
    localStorage.setItem('register_id', String(params.get('register')));
    localStorage.setItem('token_user_latam', String(params.get('token')));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchDataUser = async () => {
    setLoading(true);
    await axios
      .get(
        `${process.env.REACT_APP_API_BACKEND}/registers/${params.get(
          'register'
        )}/form`,
        {
          headers: {
            'Access-Control-Allow-Origin': '*',
            Authorization: `Bearer ${params.get('token')}`
          }
        }
      )
      .then(async (response: any) => {
        setDataUser(response.data);
        setCurrentStep(response.data[0].step);
        dispatch(updateData(response.data[0]));

        // Fetch available suppliers if none pre-set
        if (!response.data[0].supplier) {
          try {
            const suppliersRes = await axios.get(
              `${process.env.REACT_APP_API_BACKEND}/registers/${params.get('register')}/available_suppliers`,
              {
                headers: {
                  'Access-Control-Allow-Origin': '*',
                  Authorization: `Bearer ${params.get('token')}`
                }
              }
            );
            setAvailableSuppliers(suppliersRes.data);
          } catch (err) {
            console.log('Error fetching suppliers =>', err);
          }
        }
      })
      .catch((error: AxiosError) => {
        console.log('Error fetchDataUser =>', error);
        setError(true);
      })
      .finally(() => setLoading(false));
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <div className='flex flex-col justify-center items-center mb-6 py-6 sm:py-8 bg-white shadow-sm border border-gray-300 rounded-lg mt-4 sm:mt-6'>
        <div className='flex justify-between sm:justify-center sm:gap-4 max-w-6xl w-full px-4'>
          {steps?.map((step, index) => (
            <div
              key={index}
              className={`step-item ${currentStep === index + 1 && 'active'} ${(index + 1 < currentStep || complete) && 'complete'
                }`}
            >
              <p className='text-gray-500 text-sm font-medium mb-2 hidden sm:block'>{step}</p>
              <div className='step'>
                {index + 1 < currentStep || complete || currentStep == 6 ? (
                  <TiTick size={28} />
                ) : (
                  index + 1
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className="max-w-6xl mx-auto py-4 sm:py-6 lg:py-8">
      {(() => {
        if (loading) {
          return <span>Cargando...</span>;
        } else {
          if (!error) {
            switch (currentStep) {
              case 1:
                return (
                  <WelcomeSection
                    currentStep={currentStep}
                    setCurrentStep={setCurrentStep}
                    dataUser={dataUser[0]}
                  />
                )
              case 2:
                return (
                  <FormPersonalData
                    registerId={String(params.get('register'))}
                    token={String(params.get('token'))}
                    dataUser={dataUser[0]}
                    currentStep={currentStep}
                    setComplete={setComplete}
                    setCurrentStep={setCurrentStep}
                    stepsLength={steps.length}
                  />
                );
              case 3:
                return (
                  <SelectPayment
                    registerId={String(params.get('register'))}
                    token={String(params.get('token'))}
                    prices={[dataUser[0].price]}
                    dataUser={dataUser[0]}
                    currentStep={currentStep}
                    setCurrentStep={setCurrentStep}
                    paymentSelected={setPaymentMethodSelected}
                    tuition={dataUser[0].price.tuition}
                    discount={dataUser[0].discount}
                    allianceDiscount={dataUser[0].alliance_discount}
                    totalDiscountPercentage={dataUser[0].total_discount_percentage}
                    tuitionExempted={dataUser[0].tuition_exempted}
                    variantApplication={dataUser[0].variant_application}
                  />
                );
              case 4:
                return (
                  <SignDocument
                    currentStep={currentStep}
                    paymentMethod={paymentMethodSelected}
                    setCurrentStep={setCurrentStep}
                  />
                );
              case 5:
                return (
                  <SimpleFinishPayment
                    currentStep={currentStep}
                    setCurrentStep={setCurrentStep}
                    dataUser={dataUser[0]}
                    suppliers={dataUser[0].supplier ? [{ id: 0, description: dataUser[0].supplier }] : availableSuppliers}
                  />
                );
              case 6:
                return (
                  <CheckOutView
                    dataUser={dataUser[0]}
                  />
                );
              default:
                break;
            }
          } else {
            return (
              <div className='text-center font-bold w-100 py-40'>
                <p>El link de acceso ha expirado o ha sido cancelado, por favor contactate
                  a <b>inscripciones@desafiolatam.com</b></p>
              </div>
            );
          }
        }
      })()}
      </div>
    </div>
  );
};